import { Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { Disciplines as DisciplinesView } from '@modules/Disciplines/views/Disciplines';

export const Disciplines = () => {

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: 3,
      }}
    >
      <ErrorBoundary>
        <DisciplinesView />
      </ErrorBoundary>
    </Container>
  );
};
